import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { IAddCommentRequest, IAddCommentConfig, TResponses } from './types';

const defaultConfig: Required<IAddCommentConfig> = {
  pathApi: '/v1/add-comment',
  browserUrl: 'http://www.master.dev3.cian.ru/content-api',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultRequest: IHTTPRequestConfig<any> = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createAddCommentRequest({
  bodyParameters,
  config,
}: Pick<IAddCommentOptions, 'bodyParameters' | 'config'>): IHTTPRequestConfig<any> {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: transformObjectToQuery(bodyParameters as any).unwrap() as any,
  };
}

export interface IAddCommentOptions {
  httpApi: IHttpApi;
  bodyParameters: IAddCommentRequest;
  config?: IAddCommentConfig;
}

async function fetchAddComment({
  httpApi,
  bodyParameters,
  config,
}: IAddCommentOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpApi.httpRequest(createAddCommentRequest({ bodyParameters, config })) as any;
}

export { defaultConfig, createAddCommentRequest, fetchAddComment };
